import React from "react";
import ActionsContextV2 from "../ActionsContextV2";
import ActionDeviationDialogReadOnly from './ActionDeviationDialogReadOnlyV2';
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import ActionDeviationDropdown from './ActionDeviationTypeDropdownV2';
import { DeviationForExistingProjectProcedure } from "./DeviationForExistingProjectProcedure";
import { DeviationForNewProjectProcedure } from "./DeviationForNewProjectProcedure";
import { DeviationForPartiallyaddendum } from "./DeviationForPartiallyaddendum";
import { NonDeviationContent } from "./NonDeviationContent";
import { connect } from 'react-redux';
import { fetchMyRRDocs } from "../../../reduxActions/FunctionsActions";
import { fetcProjectSpecificProcedures } from "../../../reduxActions/ProjectActions";


import {
  Divider,
  Paper,
  Modal,
  Button,
  TextField,
  IconButton,
  Icon,
  Dialog
} from "@material-ui/core";
import styled from "styled-components";


const TitleContainer = styled.div`
width:100%;
color: white;
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
padding:20px;
height:80px;
background-color:RGB(48, 74, 87);
display:flex;
align-items:center;
`

const ContentContainer = styled.div`
  padding-left:20px;
  padding-right:20px;
  overflow-y:auto;

`

const ButtonsContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:flex-end;
height:80px;
padding-right:20px;
`

const ButtonContainer = styled.div`
width:90px;
margin-left:20px;
`

const Title = styled.div`

`;

const Container = styled.div`

width:760px;
display:flex;
flex-direction:column;
align-items:space-between;
 
`;

const FileButtonContainer = styled.div`
    padding-top:20px;
    display:flex;
    align-items:center;
`

const DeleteButtonContainer = styled.div`
    padding-left:20px;
`

const Subheader = styled.div`
height:50px;
display:flex;
background-color:#ECF5F9;
padding-left:20px;
padding-right:20px;
align-items:center;
justify-content:space-between;
font-family: Roboto;
font-size: 17px;
font-weight: 500;
`
class ActionDeviationDialogV2 extends React.Component {
  static contextType = ActionsContextV2;
  constructor(props) {
    super(props);

    const deviationAction = props.context.deviationAction ? props.context.deviationAction : {};

    const {
      deviationReasoning,
      deviationComments,
      modifiedProcedureSdn,
      modifiedProcedureTitle,
      modifiedProcedureUrl,
      modifiedProcedureRev = null,
      modifiedProcedureEffectiveDate = null,
      isDeviating = false,
      attachments,
      deviationType
    } = deviationAction;

    this.state = {
      deviationReasoning: (deviationReasoning === null) ? '' : deviationReasoning,
      deviationComments: (deviationComments === null) ? '' : deviationComments,
      isHaveExistingComment: (deviationComments === null) ? '' : deviationComments,
      modifiedProcedureSdn: (modifiedProcedureSdn === null) ? '' : modifiedProcedureSdn,
      modifiedProcedureTitle: (modifiedProcedureTitle === null) ? '' : modifiedProcedureTitle,
      modifiedProcedureUrl: (modifiedProcedureUrl === null) ? '' : modifiedProcedureUrl,
      modifiedRevision: (modifiedProcedureRev === null) ? '' : modifiedProcedureRev,
      modifiedEffectiveDate: (modifiedProcedureEffectiveDate === null) ? '' : modifiedProcedureEffectiveDate,
      isDeviating: isDeviating,
      selectedDeviationOption: deviationType,
      helperText: '',
      error: false,
      attachments
    }

  }



  componentDidMount() {
    if (!this.props.myRRDocs || !this.props.myRRDocs.length) {
      this.props.fetchMyRRDocs();
    }

    // if (this.props.selectedProjectId, this.props.selectedFunctionId && (!this.props.projectSpecificProcedure || !this.props.projectSpecificProcedure.length)) {
    this.props.fetcProjectSpecificProcedures(this.props.selectedProjectId, this.props.selectedFunctionId);
    // }
  }

  renderFileButton(attachment) {
    return (
      <FileButtonContainer>
        <div>
          <a href={`/api/attachments/download/${attachment.id}`}>{attachment.virtualPath}
          </a>
        </div>
        <DeleteButtonContainer>
          <IconButton onClick={() => this.context.deleteDeviationFile({ deviationFile: attachment, procedureId: this.context.deviationAction.procedureId })}>
            <DeleteIcon />
          </IconButton>
        </DeleteButtonContainer>
      </FileButtonContainer>
    )
  }

  onUrlBlur(event) {
    // const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    //   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    //   '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    //   '(\\:\\d+)?(\\/[-a-z\\d%_.~:+]*)*'+ // port and path
    //   '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    //   '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    const pattern = new RegExp(
      "(?:(?:https?|ftp)://)" + // protocol identifier
      "(?:\\S+(?::\\S*)?@)?" +     // user:pass authentication
      "(?:" + // IP address exclusion
      "(?!(?:10|127)(?:\\.\\d{1,3}){3})" + // private & local networks
      "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
      "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
      "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
      "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
      "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
      "|" +
      "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" + // host name
      "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + // domain name
      "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" + // TLD identifier
      ")" +
      "(?::\\d{2,5})?" + // port number
      "(?:[/?#](?:\\S*[^\\s!\"'()*,-.:;<>?\\[\\]_`{|}~]|))?" // resource path, excluding a trailing punctuation mark
      , "gi"
    );
    const message = !!pattern.test(this.state.modifiedProcedureUrl) || this.state.modifiedProcedureUrl.length === 0 ? undefined : 'Invalid URL';
    if (!message) {
      this.setState({ helperText: '', error: false });
    } else {
      this.setState({ helperText: message, error: true });
    }
  }

  renderButtons() {
    const { deviationFileUploads, deviationFileUploadsDeletedIndexes } = this.context;
    const fileUploaded = [];
    {
      deviationFileUploads && deviationFileUploads.map((file, index) => (!deviationFileUploadsDeletedIndexes[index] ?
        fileUploaded.push(file) : null
      ))
    }

    let enableSave = false;

    if (this.state.selectedDeviationOption == 1 || this.state.selectedDeviationOption == 0 || this.state.selectedDeviationOption == 2) {
      enableSave = !this.state.error && this.state.isDeviating && this.state.deviationReasoning && this.state.modifiedProcedureSdn && this.state.modifiedProcedureTitle
    }

    if (this.state.selectedDeviationOption == 3) {
      enableSave = !this.state.error && this.state.isDeviating && (this.state.modifiedProcedureUrl || fileUploaded.length) && this.state.deviationReasoning
    }

    if (!this.state.isDeviating) {
      enableSave = !this.state.error && this.state.deviationComments
    }

    return (
      <ButtonsContainer>
        <ButtonContainer>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {

              // if (this.context.deviationReasoningClearApplicabilityOnCancel) {
              //   this.context.updateAction(this.context.deviationAction, { applicabilityId: null })
              // }

              this.context.closeDeviationReasoning();
            }}
          >
            Cancel
          </Button>
        </ButtonContainer>
        <ButtonContainer>
          <Button
            fullWidth
            style={{ paddingLeft: 10 }}
            variant="contained"
            color="primary"
            disabled={!enableSave}
            onClick={() => {


              if (this.state.isDeviating) {
                this.context.uploadPendingDeviationFiles();
              }

              this.context.updateAction(this.context.deviationAction, {
                deviationReasoning: this.state.deviationReasoning,
                deviationComments: this.state.deviationComments,
                modifiedProcedureSdn: this.state.modifiedProcedureSdn,
                modifiedProcedureTitle: this.state.modifiedProcedureTitle,
                modifiedProcedureUrl: this.state.modifiedProcedureUrl,
                isDeviating: this.state.isDeviating,
                deviationInProgress: this.state.deviationInProgress,
                attachments: this.state.attachments,
                deviationType: this.state.selectedDeviationOption == 4 ? 0 : this.state.selectedDeviationOption,
                modifiedProcedureRev: this.state.modifiedRevision,
                modifiedProcedureEffectiveDate: this.state.modifiedEffectiveDate,

              });

              this.context.closeDeviationReasoning();


            }}
          >Save</Button>
        </ButtonContainer>
      </ButtonsContainer>

    )
  }

  render() {
    const deviationOptions = [
      {
        id: 1, label: 'Yes, with an existing project-specific procedure'
      },
      {
        id: 2, label: 'Yes, with new project-specific procedure'
      },
      {
        id: 3, label: 'Partially, with an addendum to existing procedure'
      }, {
        id: 4, label: 'Yes, the project will use prior revision of the procedure'
      }
    ]

    if (this.context.deviationAction) {

      if (!this.context.deviationAction.isEditable) {
        return <ActionDeviationDialogReadOnly />
      } else if (this.context.deviationAction.currentStepIndex > 0 && this.context.deviationAction.status !== "Approved") {
        return <ActionDeviationDialogReadOnly />
      }
    }

    const exisistingDeviationType = this.state.isDeviating === false ? this.state.isHaveExistingComment ? 4 : '' : this.state.selectedDeviationOption != 0 ? this.state.selectedDeviationOption : 1

    return (
      <>
        {this.context.deviationDialogOpen &&
          <Dialog maxWidth='xl' open={true}>
            <Container >
              <TitleContainer><Title>Enter Deviation Reasoning</Title></TitleContainer>
              <Subheader>{`Is this a deviation from the current revision of Procedure ${this.context.deviationAction.procedureSdn}?`} </Subheader>
              <ContentContainer style={{ height: window.innerHeight - 300 }}>
                <ActionDeviationDropdown
                  exisistingDeviationType={exisistingDeviationType}
                  deviationOptions={deviationOptions}
                  onChangeisDeviating={deviationOption => {
                    if (deviationOption === 1 || deviationOption === 2 || deviationOption === 3) {
                      this.setState({ ...this.state, isDeviating: true, selectedDeviationOption: deviationOption })
                    } else {
                      this.setState({ ...this.state, isDeviating: false, selectedDeviationOption: deviationOption, isHaveExistingComment: true })
                    }
                  }}
                />
                {this.state.isDeviating == true && (this.state.selectedDeviationOption === 1 || exisistingDeviationType == 1) &&
                  < DeviationForExistingProjectProcedure
                    sdnValue={this.state.modifiedProcedureSdn}
                    modifiedProcedureTitle={this.state.modifiedProcedureTitle}
                    modifiedProcedureUrl={this.state.modifiedProcedureUrl}
                    onSdnChange={changedValues => this.setState({ ...this.state, modifiedProcedureSdn: changedValues.sdn, modifiedProcedureTitle: changedValues.name, modifiedProcedureUrl: changedValues.url, modifiedRevision: changedValues.rev ? changedValues.rev : '', modifiedEffectiveDate: changedValues.effectiveDate ? changedValues.effectiveDate : '' })}
                    deviationReasoning={this.state.deviationReasoning}
                    onReasoningChange={event => this.setState({ ...this.state, deviationReasoning: event.target.value })}
                    myRRDocs={this.props.projectSpecificProcedure}
                  />
                }
                {this.state.isDeviating == true && this.state.selectedDeviationOption === 2 &&
                  <DeviationForNewProjectProcedure
                    deviationReasoning={this.state.deviationReasoning}
                    onDeviationReasoningChange={event => this.setState({ deviationReasoning: event.target.value })}
                    modifiedProcedureSdn={this.state.modifiedProcedureSdn}
                    onChangeSdn={changedValues => {
                      this.setState({ modifiedProcedureSdn: changedValues.sdn, modifiedProcedureTitle: changedValues.name, modifiedProcedureUrl: changedValues.url, modifiedRevision: changedValues.rev ? changedValues.rev : '', modifiedEffectiveDate: changedValues.effectiveDate ? changedValues.effectiveDate : '' })
                    }}
                    modifiedProcedureTitle={this.state.modifiedProcedureTitle}
                    modifiedRevision={this.state.modifiedRevision}
                    onChangeModifiedProcedureTitle={event => this.setState({ modifiedProcedureTitle: event.target.value })}
                    onChangeModifiedProcedureRevision={event => this.setState({ modifiedRevision: event.target.value })}
                    modifiedProcedureUrl={this.state.modifiedProcedureUrl}
                    onChangeModifiedProcedureUrl={event => this.setState({ modifiedProcedureUrl: event.target.value })}
                    modifiedEffectiveDate={this.state.modifiedEffectiveDate}
                    onChangeModifiedProcedureEffectiveDate={event => this.setState({ modifiedEffectiveDate: event.target.value })}
                    onUrlBlur={this.onUrlBlur.bind(this)}
                    helperText={this.state.helperText}
                    myRRDocs={this.props.myRRDocs}
                    error={this.state.error}
                  />
                }
                {this.state.isDeviating == true && this.state.selectedDeviationOption === 3 &&
                  <DeviationForPartiallyaddendum
                    modifiedProcedureUrl={this.state.modifiedProcedureUrl}
                    onChangeModifiedProcedureUrl={event => this.setState({ modifiedProcedureUrl: event.target.value })}
                    onUrlBlur={this.onUrlBlur.bind(this)}
                    helperText={this.state.helperText}
                    error={this.state.error}
                    attachments={this.state.attachments}
                    onDeleteAttachment={index => {
                      const attachments = [...this.state.attachments];

                      attachments[index].isDeleted = true;
                      this.setState({ attachments });
                    }}
                    deviationReasoning={this.state.deviationReasoning}
                    onChangeDeviationReasoning={event => this.setState({ deviationReasoning: event.target.value })}
                  />}
                {this.state.isDeviating === false && this.state.isHaveExistingComment &&
                  < NonDeviationContent
                    deviationComments={this.state.deviationComments}
                    onChangeDeviationComments={event => this.setState({ deviationComments: event.target.value })}
                  />
                }
              </ContentContainer>
            </Container>
            <Divider />
            {this.renderButtons()}
          </Dialog>
        }
      </>
    );
  }
}

// export default ActionDeviationDialogV2;

export default ActionDeviationDialogV2 = connect((state) => {
  const { functions, procedures, actions } = state;
  return {
    myRRDocs: functions.myRRDocs,
    projectSpecificProcedure: procedures.projectSpecificProcedures.length && procedures.projectSpecificProcedures.filter(procedure => !procedure.archived).map((procedure, index) => {
      return {
        documentLink: procedure.url,
        documentRevision: procedure.rev,
        documentTitle: procedure.name,
        effectiveDate: procedure.effectiveDate,
        id: procedure.id,
        projectNumber: procedure.projectId,
        sdn: procedure.sdn,
        isNew: procedure.isNew,

      }
    }),
    selectedProjectId: actions.selectedProject.id || null,
    selectedFunctionId: actions.selectedProject.selectedFunction.id || null,
  };
}, { fetchMyRRDocs, fetcProjectSpecificProcedures })(ActionDeviationDialogV2);
